export const themeMaxWidth = {
  none: 'none',
  desktop: '1024px',
  '1/2': '50%',
  'max-content': 'max-content'
} as const;
